@if (readOnly) {
  @if (existingFiles.length > 0) {
    <div class="file-list">
      @for (file of existingFiles; track file) {
        <div class="file-item">
          <div class="file-item-left">
            <fa-icon
              [icon]="getFilePresentation(file.fileName).icon"
              [ngClass]="getFilePresentation(file.fileName).class"
              class="file-type-icon">
            </fa-icon>
            <div class="file-meta">
              <div class="file-item-name">{{ file.fileName }}</div>
              <div class="file-item-date">
                {{ file.utcCreated | date:'yyyy-MM-dd HH:mm' }}
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
  @if (existingFiles.length === 0) {
    <div class="empty-state">
      {{ 'files.noAttachments' | translate }}
    </div>
  }
} @else {
  <div class="file-upload-card">
    <input
      #fileUpload
      type="file"
      multiple
      class="d-none"
      (change)="onFileSelected($event)"
      />
      <div
        class="file-upload-dropzone"
        [class.drag-over]="isDragOver"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
        >
        <div class="file-upload-text">
          <div class="file-upload-title">
            {{ 'files.selectToUpload' | translate }}
          </div>
          <div class="file-upload-help">
            {{ 'files.dragAndDrop' | translate }}
          </div>
          <div class="file-upload-help">
            {{ 'files.maxLimit' | translate }}
          </div>
        </div>
        <div class="file-upload-actions">
          <button
            type="button"
            class="btn btn-primary btn-sm"
            (click)="fileUpload.click()"
            >
            <fa-icon [icon]="faPaperclip" size="sm" class="me-1"></fa-icon>
            {{ 'files.selectFiles' | translate }}
          </button>
          <button
            type="button"
            class="btn btn-link btn-sm clear-btn"
            (click)="clear()"
            [disabled]="files.length === 0"
            >
            {{ 'files.clearAll' | translate }}
          </button>
        </div>
      </div>
      @if (files.length > 0) {
        <div class="file-list">
          <div class="file-list-title">
            {{ 'files.selectedFiles' | translate:{ count: files.length } }}
          </div>
          @for (file of files; track file; let i = $index) {
            <div class="file-item">
              <div class="file-item-left">
                <fa-icon
                  [icon]="getFilePresentation(file.name).icon"
                  [ngClass]="getFilePresentation(file.name).class"
                  class="file-type-icon">
                </fa-icon>
                <div class="file-meta">
                  <div class="file-item-name">{{ file.name }}</div>
                  <div class="file-item-size">
                    {{ (file.size / 1024 / 1024).toFixed(2) }} MB
                  </div>
                </div>
              </div>
              <button
                type="button"
                class="btn btn-link btn-sm remove-btn"
                (click)="removeFile(i)"
                >
                {{ 'files.remove' | translate }}
              </button>
            </div>
          }
        </div>
      }
      @if (files.length === 0) {
        <div class="empty-state">
          {{ 'files.noneSelected' | translate }}
        </div>
      }
      @if (errorText) {
        <div class="file-error">
          {{ errorText }}
        </div>
      }
    </div>
  }

